import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { IOfferLine } from '~shared/modules/cart/models';

export class RemoveFromCartApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.RemoveFromCart;

  constructor(private productId: string, private offerLine: IOfferLine, private removedItem: string) {}

  getPayload(): any {
    return {
      productId: this.productId,
      offerLine: this.offerLine,
      removedItem: this.removedItem,
    };
  }
}
